"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  if (localStorage.getItem("mcn_seen") === null) {
    setTimeout(handlers.openModal, 5000);
    handlers.openModal();
    $("#mce-MMERGE3-day").attr("value", "15");
  }
  $("#mc-embedded-subscribe").on("submit", function (e) {
    localStorage.setItem("mcn_seen", "true");
  });
  $(Dom.mailChimpCloseModal).on("click", function (event) {
    event.preventDefault();
    handlers.closeModal();
    localStorage.setItem("mcn_seen", "true");
  });
  $(Dom.overlay).on("click", function (event) {
    event.preventDefault();
    handlers.closeModal();
  });
};
